<template>
  <div>
    <el-card style="position: relative">
      <p class="title_p">基本配置</p>
      <el-button
        type="primary"
        class="edit_position"
        @click="basicConfigFlag = !basicConfigFlag"
        size="mini"
        >编 辑</el-button
      >
      <el-button
        type="primary"
        class="btn_position"
        @click="addDict()"
        size="mini"
        >添 加</el-button
      >

      <el-form class="basic_config">
        <el-form-item
          v-for="item in basicConfig"
          :label="item.description"
          :key="item.id"
          label-width="250px"
        >
          <el-input
            :disabled="basicConfigFlag"
            v-model="item.dictValue"
            style="max-width: 700px; min-width: 200px"
          ></el-input>
          <el-button
            style="right: 100px"
            type="primary"
            class="btn_position"
            :disabled="basicConfigFlag"
            @click="basicConfigs(item)"
            size="mini"
            >确定</el-button
          >
          <el-button
            style="margin-left: 30px"
            type="danger"
            class="btn_position"
            :disabled="basicConfigFlag"
            @click="deleteId(item.id)"
            size="mini"
            >删除</el-button
          >
        </el-form-item>

        <div v-for="i in dData" :key="i.id">
          <el-form-item label="尖时：" label-width="250px">
            <el-input
              :disabled="basicConfigFlag"
              v-model="i.dictValue.fee1"
              style="max-width: 400px; min-width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="峰时：" label-width="250px">
            <el-input
              :disabled="basicConfigFlag"
              v-model="i.dictValue.fee2"
              style="max-width: 400px; min-width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="平时：" label-width="250px">
            <el-input
              :disabled="basicConfigFlag"
              v-model="i.dictValue.fee3"
              style="max-width: 400px; min-width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="谷时：" label-width="250px">
            <el-input
              :disabled="basicConfigFlag"
              v-model="i.dictValue.fee4"
              style="max-width: 400px; min-width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="高尖时：" label-width="250px">
            <el-input
              :disabled="basicConfigFlag"
              v-model="i.dictValue.fee5"
              style="max-width: 400px; min-width: 200px"
            ></el-input>
            <el-button
              style="right: 100px"
              type="primary"
              class="btn_position"
              :disabled="basicConfigFlag"
              @click="basicConfigs(i, 1)"
              size="mini"
              >确定</el-button
            >
            <el-button
              style="margin-left: 30px"
              type="danger"
              class="btn_position"
              :disabled="basicConfigFlag"
              @click="deleteId(i.id)"
              size="mini"
              >删除</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </el-card>

    <el-dialog
      class="confirms"
      title="添加"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-card class="box-card">
        <el-form label-width="100px">
          <el-form-item label="属性名：">
            <el-input v-model="dataMap.label"></el-input>
          </el-form-item>
          <el-form-item label="值：">
            <el-input v-model="dataMap.dictValue"></el-input>
          </el-form-item>
          <el-form-item label="描述：">
            <el-input v-model="dataMap.description"></el-input>
          </el-form-item>
        </el-form>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleClose()">取 消</el-button>
        <el-button type="primary" size="mini" @click="add_edit()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { AxiosAjax } from "../js/axios.config";

export default {
  data() {
    return {
      basicConfigFlag: true,
      basicConfig: [],
      //   dData: {
      //     id: 0,
      //     label: "",
      //     dictValue: "",
      //     description: "",
      //   },
      dData: [],
      //   feePlatform: {
      //     fee1: 0,
      //     fee2: 0,
      //     fee3: 0,
      //     fee4: 0,
      //     fee5: 0,
      //   },
      dataMap: {
        label: "",
        dictValue: "",
        description: "",
      },
      dialogVisible: false,
    };
  },
  methods: {
    initData() {
      const _this = this;
      this.basicConfig = [];
      this.dData = [];
      AxiosAjax({
        url: "/cabinet/dict/page?index=" + 1 + "&size=" + 99,
        success: function (res) {
          res.data.data.records.forEach(function (item) {
            if (item.description === "大屏展示的其他地址的经纬度") {
            } else if (item.description === "平台电价配置") {
              try {
                item.dictValue = JSON.parse(item.dictValue);
              } catch (error) {
                var jsonString = item.dictValue.replace(/&quot;/g, '"');
                item.dictValue = JSON.parse(jsonString);
              }
              _this.dData.push(item);
            } else {
              _this.basicConfig.push(item);
            }
          });
        },
      });
    },
    basicConfigs(item, i) {
      const _this = this;
      let data = null;
      if (i == 1) {
        item.dictValue = JSON.stringify(item.dictValue);
        data = item;
      } else {
        data = item;
      }
      AxiosAjax({
        url: "/cabinet/dict/update",
        method: "put",
        data: data,
        success: function (res) {
          if (res.data.msg) {
            _this.initData();
          }
        },
      });
    },
    addDict() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    add_edit() {
      const _this = this;
      AxiosAjax({
        url: "/cabinet/dict/save",
        method: "post",
        data: _this.dataMap,
        success: function (res) {
          if (res.data.msg) {
            _this.dialogVisible = false;
            _this.dataMap = {};
            _this.initData();
          }
        },
      });
    },
    deleteId(id) {
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteDict(id);
        })
        .catch(() => {});
    },
    deleteDict(id) {
      const _this = this;
      AxiosAjax({
        url: "/cabinet/dict/" + id,
        method: "delete",
        success: function (res) {
          _this.initData();
        },
      });
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
<style scoped>
.title_p {
  text-align: left;
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
  padding-bottom: 16px;
  font-weight: 600;
}
.btn_position {
  position: absolute;
  top: 12px;
  right: 20px;
}
.edit_position {
  position: absolute;
  top: 12px;
  right: 120px;
}
.basic_config /deep/ .el-form-item__content {
  text-align: left;
}
.el-card {
  margin: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/MoreParameters.vue